import React, { useState, useEffect } from 'react';
import { Avatar, AvatarProps } from '@mui/material';

const GoogleProfileImage = ({ 
  src, 
  alt, 
  fallbackText, 
  size = 'medium',
  healthStatus = 'healthy', // 'healthy' | 'warning' | 'error'
  ...avatarProps 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  
  // Health status border colors
  const healthColors = {
    healthy: '#4caf50',  // Green
    warning: '#ff9800',  // Orange/Yellow
    error: '#f44336'     // Red
  };

  useEffect(() => {
    if (src && !imageError) {
      // Si es una imagen de Google, usar el proxy del backend
      if (src.includes('googleusercontent.com')) {
        // Detectar si estamos en producción o desarrollo
        const apiBaseUrl = window.location.hostname === 'localhost' 
          ? 'http://localhost:8000'
          : window.location.origin;
        const proxyUrl = `${apiBaseUrl}/api/v1/conversations/proxy/image?url=${encodeURIComponent(src)}`;
        console.log('Using proxy URL for Google image:', proxyUrl);
        setImageSrc(proxyUrl);
      } else {
        setImageSrc(src);
      }
    }
  }, [src, imageError]);

  const handleImageError = () => {
    console.error('Failed to load Google profile image:', src);
    setImageError(true);
    setImageSrc(null);
    
    // Intentar con una URL alternativa si es de Google
    if (src && src.includes('googleusercontent.com')) {
      console.log('Trying alternative Google image URL...');
      // Remover parámetros de tamaño y agregar uno más grande
      const alternativeUrl = src.replace(/=s\d+-c/, '=s200-c');
      console.log('Alternative URL:', alternativeUrl);
      // No cambiar automáticamente, solo log para debug
    }
  };

  const handleImageLoad = () => {
    console.log('Google profile image loaded successfully:', src);
    setImageError(false);
  };

  // Si no hay src o hay error, mostrar solo el fallback
  if (!imageSrc || imageError) {
    return (
      <Avatar
        {...avatarProps}
        sx={{
          ...avatarProps.sx,
          bgcolor: '#00CDFF',
          color: '#fff',
          fontWeight: 'bold',
          border: `2px solid ${healthColors[healthStatus]}`,
          boxShadow: `0 0 8px ${healthColors[healthStatus]}40`,
          transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        }}
      >
        {fallbackText}
      </Avatar>
    );
  }

  return (
    <Avatar
      {...avatarProps}
      src={imageSrc}
      imgProps={{
        crossOrigin: 'anonymous',
        referrerPolicy: 'no-referrer',
        onError: handleImageError,
        onLoad: handleImageLoad
      }}
      sx={{
        ...avatarProps.sx,
        bgcolor: '#00CDFF',
        color: '#fff',
        border: `2px solid ${healthColors[healthStatus]}`,
        boxShadow: `0 0 8px ${healthColors[healthStatus]}40`,
        transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
      }}
    >
      {fallbackText}
    </Avatar>
  );
};

export default GoogleProfileImage;
